/** Draws whichever view is open. Views are looked up in the registry, so a
 *  plugin's view opens exactly like a built-in one. */

import { pluginsSettled } from "../core/plugins";
import { useApp } from "../core/app";
import { useRegistry } from "../core/registry";
import { PlaylistView } from "../views/PlaylistView";
import { SongsView } from "../views/SongsView";

/** Views that bring their own right-hand panel, so the details panel stays shut. */
export const OWN_PANEL = new Set(["flow", "studio", "plugins"]);

export function ViewHost() {
  const app = useApp();
  const { views } = useRegistry();
  const { view, params } = app.nav;
  if (view === "playlist" && params.id) return <PlaylistView id={Number(params.id)} />;
  const found = views.find((v) => v.id === view);
  // A plugin's screen appears once the plugins have loaded; until then show nothing
  // rather than flash Songs first.
  if (!found) return pluginsSettled() ? <SongsView /> : null;
  return <>{found.render({ navigate: app.navigate, params })}</>;
}
